import { url as isValidUrl, helpers } from 'vuelidate/lib/validators';
import { parseSize } from './util';

export const image = file => Boolean(file?.type?.startsWith('image'));

export const unique = (value, list) => !list.includes(value);

export const uniqueUrl = (value, list) => {
    const createClearUrl = urlString => {
        const validUrlString = /(http(s?)):\/\//i.test(urlString) ? urlString : `http://${urlString}`;
        if (!isValidUrl(validUrlString)) return urlString;
        const urlData = new URL(validUrlString);
        const hostWithoutWWW = urlData.host.startsWith('www.') ? urlData.host.replace('www.', '') : urlData.host;
        const url = hostWithoutWWW + urlData.pathname + urlData.search;
        return url;
    };
    const url = createClearUrl(value);
    const urlList = list.map(createClearUrl);
    return !urlList.includes(url);
};

export const url = value => {
    try {
        new URL(value); // eslint-disable-line no-new
        return value.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm).length === 1; // eslint-disable-line no-useless-escape
    } catch {
        return false;
    }
};

export const hexColor = value => {
    const regex = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;
    return regex.test(value);
};

export const iban = value => {
    try {
        const regex = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{1,30}$/;
        return regex.test(value);
    } catch {
        return false;
    }
};

export const fileSize = ({ min = null, max = null }) =>
    helpers.withParams({ type: 'fileSize', min, max }, value => {
        if (!value || !(value instanceof File)) return true;

        const sizeValue = value.size;

        if (min && sizeValue <= parseSize(min)) return false;
        if (max && sizeValue >= parseSize(max)) return false;

        return true;
    });
